
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Plane } from 'lucide-react';

interface FlightNumberFieldProps {
  flightNumber: string;
  onChange: (value: string) => void;
}

const FlightNumberField: React.FC<FlightNumberFieldProps> = ({ 
  flightNumber, 
  onChange
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = e.target.value.replace(/\s+/g, '').toUpperCase();
    onChange(formattedValue);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="flight-number">Flight Number</Label>
      <div className="relative">
        <Plane className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input 
          id="flight-number" 
          value={flightNumber}
          onChange={handleInputChange}
          placeholder="e.g., AA1234"
          className="pl-9"
        />
      </div>
      <p className="text-xs text-muted-foreground">
        Enter your flight number (e.g., AA1234)
      </p>
    </div>
  );
};

export default FlightNumberField;
